import { Suspense, lazy } from "react";
import styled from "styled-components";

export const Loader = () => {
  return (
    <StyledLoader className="loader">
      <span></span>
      <span></span>
    </StyledLoader>
  );
};

// eslint-disable-next-line react/display-name
const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<Loader></Loader>}>
      <Component {...props} />
    </Suspense>
  );

// AUTH -------------------------------------
const Authentication = Loadable(lazy(() => import("../pages/auth/index")));

// SHOP -------------------------------------
const ShopHomePage = Loadable(lazy(() => import("../pages/ShopHomePage")));
const CategorySinglePage = Loadable(
  lazy(() => import("../pages/category/[id]/InnerCategory"))
);
const ProductsDetailPage = Loadable(
  lazy(() => import("../pages/products/[id]/ProductDetails"))
);
const ProductsDeliveryPage = Loadable(
  lazy(() => import("../pages/products/delivery"))
);
const CartPage = Loadable(lazy(() => import("../pages/cart/index")));
const OrderPaymentPage = Loadable(
  lazy(() => import("../pages/order/OrderPayment"))
);

const OrderPlacedPage = Loadable(
  lazy(() => import("../pages/order/order-placed"))
);

const OrderDeliveryPage = Loadable(
  lazy(() => import("../pages/order/delivery"))
);
const MyOrdersPage = Loadable(
  lazy(() => import("../pages/order/my-orders/index"))
);

const MyOrderTrackingPage = Loadable(
  lazy(() => import("../pages/order/my-orders/[id]/index"))
);
const MyOrderCancelledDetailsPage = Loadable(
  lazy(() => import("../pages/order/my-orders/[id]/OrderDetailsCancelled"))
);
const MyOrderReturnDetailsPage = Loadable(
  lazy(() => import("../pages/order/my-orders/[id]/OrderDetailsReturn"))
);
const ReturnRequestFormPage = Loadable(
  lazy(() => import("../pages/products/ReturnRequestFormPage"))
);

const MyCancelOrderPage = Loadable(
  lazy(() => import("../pages/order/my-orders/[id]/cancel/CancelOrder"))
);

const OrderProductsReturnPage = Loadable(
  lazy(() => import("../pages/products/return"))
);

// const MyCancelOrderSuccessPage = Loadable(
//   lazy(() => import("../pages/order/my-orders/[id]/cancel/success"))
// );

// const MyOrderRefundSuccessPage = Loadable(
//   lazy(() => import("../pages/order/my-orders/[id]/refund/success"))
// );

const MyOrderHistoryPage = Loadable(
  lazy(() => import("../pages/order/order-history/index"))
);

// SERVICES -------------------------------------
const ServicesPage = Loadable(
  lazy(() => import("pages/services/ServicesHomePage"))
);
const ServicesDetailsPage = Loadable(
  lazy(() => import("../pages/services/[id]/ServicesDetailPage"))
);
const BookedServicesPage = Loadable(
  lazy(() => import("../pages/booked-services/index"))
);
const MyBookServiceCancelledDetailsPage = Loadable(
  lazy(() =>
    import("../pages/booked-services/[id]/BookServiceDetailsCancelled")
  )
);

// new start
const ServicesBookingPage = Loadable(
  lazy(() => import("../pages/services/booking/ServicesBookingPage"))
);
// new end

// old start
const ServicesBookShortTimePage = Loadable(
  lazy(() => import("../pages/services/[id]/book-short-time"))
);

const ServicesBookLongTimePage = Loadable(
  lazy(() => import("../pages/services/[id]/book-long-time"))
);
const ServicesBookDetailsShortPage = Loadable(
  lazy(() => import("../pages/services/[id]/book-details-short"))
);

const ServicesBookDetailsLongPage = Loadable(
  lazy(() => import("../pages/services/[id]/book-details-long"))
);

const OrderServicePaymentPage = Loadable(
  lazy(() => import("../pages/services/[id]/payment"))
);
// old end

// REWARDS -------------------------------------
const RewardsShopPage = Loadable(
  lazy(() => import("../pages/rewards/RewardsShopPage"))
);

const RewardsDetailsPage = Loadable(
  lazy(() => import("../pages/rewards/[id]"))
);

const RewardsDeliveryPage = Loadable(
  lazy(() => import("../pages/rewards/[id]/delivery"))
);

// USER -------------------------------------
const ProfilePage = Loadable(
  lazy(() => import("../pages/profile/ProfilePage"))
);

const SavedAddressPage = Loadable(
  lazy(() => import("../pages/profile/saved-address"))
);
// user-location
const MyLocationPage = Loadable(
  lazy(() => import("../pages/my-location/index"))
);
const PlacesNearYouPage = Loadable(
  lazy(() => import("../pages/places-near-you/index"))
);

// user-delivery address
const AddDeliveryAddressPage = Loadable(
  lazy(() => import("../pages/delivery-address/add"))
);

const EditDeliveryAddressPage = Loadable(
  lazy(() => import("../pages/delivery-address/[id]/edit"))
);

const authProtectedRoutes = [
  // SHOP ---------------------------
  { path: "/shop", component: <ShopHomePage /> },
  { path: "/shop/category/:categoryId", component: <CategorySinglePage /> },
  { path: "/shop/products/:id", component: <ProductsDetailPage /> },
  { path: "/shop/products/delivery", component: <ProductsDeliveryPage /> },
  { path: "/cart", component: <CartPage /> },
  { path: "/order/payment", component: <OrderPaymentPage /> },
  { path: "/order/order-placed", component: <OrderPlacedPage /> },
  { path: "/order/delivery", component: <OrderDeliveryPage /> },
  { path: "/order/my-orders", component: <MyOrdersPage /> },
  { path: "/order/my-orders/:id", component: <MyOrderTrackingPage /> },
  {
    path: "/order/my-orders/cancelled-details/:id",
    component: <MyOrderCancelledDetailsPage />,
  },
  {
    path: "/order/my-orders/return-details/:transactionId",
    component: <MyOrderReturnDetailsPage />,
  },
  {
    path: "/order/my-orders/request-form/:transactionId",
    component: <ReturnRequestFormPage />,
  },
  { path: "/order/my-orders/:id/cancel", component: <MyCancelOrderPage /> },
  { path: "/order/my-orders/return", component: <OrderProductsReturnPage /> },
  { path: "/order/order-history", component: <MyOrderHistoryPage /> },

  // SERVICES ---------------------------
  { path: "/shop/services", component: <ServicesPage /> },
  { path: "/shop/services/:id", component: <ServicesDetailsPage /> },
  { path: "/booked-services", component: <BookedServicesPage /> },
  {
    path: "/booked-services/cancelled-details/:id",
    component: <MyBookServiceCancelledDetailsPage />,
  },
  // new start
  {
    path: "/shop/services/booking",
    component: <ServicesBookingPage />,
  },
  // new end

  // old start
  {
    path: "/shop/services/:id/book-short-time",
    component: <ServicesBookShortTimePage />,
  },
  {
    path: "/shop/services/:id/book-long-time",
    component: <ServicesBookLongTimePage />,
  },
  {
    path: "/shop/services/:id/book-details-short",
    component: <ServicesBookDetailsShortPage />,
  },
  {
    path: "/shop/services/:id/book-details-long",
    component: <ServicesBookDetailsLongPage />,
  },
  {
    path: "/shop/services/:id/order-payment",
    component: <OrderServicePaymentPage />,
  },
  // old end

  // REWARDS ---------------------------
  { path: "/shop/rewards", component: <RewardsShopPage /> },
  { path: "/shop/rewards/:id", component: <RewardsDetailsPage /> },
  { path: "/shop/rewards/:id/delivery", component: <RewardsDeliveryPage /> },

  // USER ---------------------------
  { path: "/profile", component: <ProfilePage /> },
  { path: "/profile/saved-address", component: <SavedAddressPage /> },
  // user-location
  { path: "/my-location", component: <MyLocationPage /> },
  { path: "/places-near-you", component: <PlacesNearYouPage /> },
  // user-delivery address
  { path: "/delivery-address/add", component: <AddDeliveryAddressPage /> },
  {
    path: "/delivery-address/:id/edit",
    component: <EditDeliveryAddressPage />,
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/authenticate" />,
  // },
];

const publicRoutes = [{ path: "/", component: <Authentication /> }];

const StyledLoader = styled("div")``;

export { authProtectedRoutes, publicRoutes };
